<button type="button"
  class="customHeaderLabel"
  [disabled]="isDisabled"
  [attr.aria-expanded]="!isCollapsed"
  (click)="toggleCollapsed()">
  <svg class="icon row-expanded" aria-hidden="true"><use xlink:href="#icon-minus" /></svg>
  <span style="vertical-align: middle" title="{{displayName}}">{{displayName}}</span>
</button>
<svg width="32" height="32">
  <symbol id="icon-Add_another" viewBox="0 0 10 10">
    <path d="M20 10v0c0 0.6-0.4 1-1 1h-18c-0.5 0-1-0.4-1-1v0c0-0.5 0.4-1 1-1h18c0.6 0 1 0.4 1 1z"></path>
    <path d="M10 20v0c-0.6 0-1-0.4-1-1v-18c0-0.5 0.4-1 1-1v0c0.5 0 1 0.4 1 1v18c0 0.6-0.4 1-1 1z"></path>
  </symbol>
  <symbol id="icon-minus" viewBox="-15 -5 25 30">
    <path d="M2 9h16v2h-16v-2z"></path>
  </symbol>
</svg>
